module.exports = {
          srcSet: __webpack_public_path__ + "4957499012a632cfef7924fe5033f4b3-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "4957499012a632cfef7924fe5033f4b3-1168.png",width: 1168,height: 234}],
          src: __webpack_public_path__ + "4957499012a632cfef7924fe5033f4b3-1168.png",
          toString:function(){return __webpack_public_path__ + "4957499012a632cfef7924fe5033f4b3-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AF2Q/v1ZjP7/SYL+/kl7/v8yZP3/K17//3x15f59duv+cH7d/zlb9/sAO5f/+0ua/v9Olf7+Q4n+/zZ6/v9Efvz+UHv9/1Ju7P5ofN//KlP9+cAVNtFOKzc1AAAAAElFTkSuQmCC",
          width: 1168,
          height: 234
        }